export enum ThemeRadii {
  Checkbox = 'checkbox',
}
